import {HeaderActions, PageHeader, ReportActions} from "components/Reports/components";
import "assets/styles/reports/balanceSheet.scss";
import BalanceSheetList from "./BalanceSheetList";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect} from "react";
import {apiGetBalanceSheet} from "api/reportApi";
import {Container} from "@mui/material";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import useDateState from "helpers/useDateState";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { ExportContainer, Item, StyledListItemIcon, StyledListItemText } from "../Table/ExportBotton";
import SnippetFolderIcon from "@mui/icons-material/SnippetFolder";

const tab = {
    title: "تراز نامه",
    description: "گزارش ترازنامه کسب و کار",
};

export default function BalanceSheetComponent() {
    const dispatch = useDispatch();
    const {toDate, fromDate, setDates} = useDateState();
    //@ts-ignore
    const {token} = useSelector((state) => state).businessReducer.business;
    //@ts-ignore
    const {balanceSheet} = useSelector((state) => state).reportReducer as {
        balanceSheet: balanceSheetDataType;
    };

    let balanceSheetData: {}[] = []

    function addBalanceSheetItem(item: any){
        balanceSheetData.push(item)
    }

    function exportExcelFile(){
        const worksheet = XLSX.utils.json_to_sheet(balanceSheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, 'exported_balance_sheet_data.xlsx');
    }

    // useEffect(() => {
    //     // @ts-ignore
    //     dispatch(apiGetBalanceSheet(token));
    // }, [token]);

    useEffect(() => handleDateFilter(), [toDate, fromDate]);

    function handleDateFilter() {
        let params = {};
        if (fromDate && toDate) {
            params = {
                subColumn: "date",
                searchText: fromDate,
                searchTextAlt: toDate,
            };
        }
        // @ts-ignore
        dispatch(apiGetBalanceSheet(token, params));
    }

    return (
        <Container maxWidth="lg">
            <div className="warp-table">
                <div className="header-table">
                    <PageHeader tab={tab}/>
                    <HeaderActions/>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 20 }} className={"flex flex-row"}>
                    <ReportActions />
                    <div style={{ width: 300 }}>
                        <BasicDateInput
                          range
                          placeholder="کل سال مالی"
                          onChange={(dates) => setDates(dates)}
                          defaultValues={fromDate && toDate ? [fromDate, toDate] : undefined}
                        />
                    </div>
                    <div style={{ width: 200 }}>
                        <ExportContainer>
                            <Item disableRipple onClick={() => exportExcelFile()}>
                                <StyledListItemIcon>
                                    <SnippetFolderIcon color="success" />
                                </StyledListItemIcon>
                                <StyledListItemText>دانلود اکسل</StyledListItemText>
                            </Item>
                        </ExportContainer>
                    </div>
                </div>
                <div style={{ width: "100%", height: 40 }} />
                {balanceSheet &&
                  <BalanceSheetList data={balanceSheet.childs} addBalanceSheetItem={addBalanceSheetItem} />}
            </div>
        </Container>
    );
}
